import { POLYGONS } from "../ThreeJs/Global/variables";
import { getOrCreateCache } from "./IrradianceCache";

export function hasComputedIrradiance(segment) {
  if (!segment?.id) return false;

  const cache = getOrCreateCache(segment.id);
  const asa =
    cache?.asa ??
    segment?.irradiance?.ASA ??
    segment?.irradiance?.asa ??
    null;
  const monthlyASA = cache?.monthlyASA ?? segment?.irradiance?.monthlyASA;
  const irradiancePoints =
    cache?.irradiancePoints ?? segment?.irradiance?.irradiancePoints;
  const displayPoints = cache?.displayPoints;

  return Boolean(
    cache?.status?.asa === "done" &&
      typeof asa === "number" &&
      Number.isFinite(asa) &&
      Array.isArray(monthlyASA) &&
      monthlyASA.length > 0 &&
      ((Array.isArray(displayPoints) && displayPoints.length > 0) ||
        (Array.isArray(irradiancePoints) && irradiancePoints.length > 0))
  );
}

export function getSegmentsMissingIrradiance(segments = POLYGONS) {
  return (segments || []).filter((segment) => !hasComputedIrradiance(segment));
}

export function collectIrradianceDisplayPoints(segments = POLYGONS) {
  return (segments || []).flatMap((segment, index) => {
    const cache = getOrCreateCache(segment?.id);
    const points = Array.isArray(cache?.displayPoints) ? cache.displayPoints : [];

    return points.map((point) => ({
      ...point,
      segmentId: segment?.id ?? null,
      segmentIndex: index,
    }));
  });
}

export function buildIrradianceProgressNotice({
  totalSegments,
  completedSegments = 0,
  followUpLabel = "",
}) {
  const safeTotal = Math.max(0, Number(totalSegments) || 0);
  const safeCompleted = Math.max(
    0,
    Math.min(safeTotal, Number(completedSegments) || 0)
  );

  return {
    visible: safeTotal > 0,
    title: `Calculating irradiance for ${safeTotal} segment${safeTotal === 1 ? "" : "s"}`,
    subtitle: followUpLabel
      ? `${safeCompleted} of ${safeTotal} complete. ${followUpLabel} will continue automatically.`
      : `${safeCompleted} of ${safeTotal} complete.`,
    intent: "info",
    source: "irradiance-progress",
    progressCurrent: safeCompleted,
    progressTotal: safeTotal,
  };
}
